import multiguard from 'vue-router-multiguard';
import middleware from '@/router/middleware';

import Index from '@/views/satellite/Index';
import Purchase from '@/views/satellite/Purchase';
import Active from '@/views/satellite/Active';
import About from '@/views/satellite/About';

export default {
  path: 'satellite',
  component: Index,
  name: 'satellite',
  meta: { title: 'Satellite' },
  children : [
    {
      path: 'active',
      component: Active,
      meta: { title: 'Active fields' },
      name : 'satellite-active',
      children: [
        {
          path: 'purchase',
          component: Purchase,
          meta: { title: 'Purchase' },
          name : 'satellite-purchase',
          props: (route) => ({ query: route.query.id })
        },
      ]
    },
    {
      path: 'about',
      component: About,
      name: 'satelliute-about',
      meta: { title: 'Vultus integration' }
    }
  ]
};
